import React, { useEffect } from "react";
import AboutAreaOne from "../components/AboutAreaOne";
import Breadcrumb from "../components/Breadcrumb";
import FaqAreaOne from "../components/FaqAreaOne";
import AboutAreaTwo from "../components/AboutAreaTwo";
import FooterThree from "../components/FooterThree";
import NavbarThree from "../components/NavbarThree";
import AboutCollabration from "../components/AboutCollabration";

const About = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      {/* Navigation Bar */}
      <NavbarThree />

      {/* Breadcrumb */}
      <Breadcrumb title={"About Us"} />

      {/* About Collabration */}
      <AboutCollabration />

      {/* About Area One */}
      <AboutAreaOne />

      {/* FAQ Area One */}
      <FaqAreaOne />

      {/* About Area Two */}
      <AboutAreaTwo />

      {/* Footer */}
      <FooterThree />
    </>
  );
};

export default About;
